module.exports = __webpack_public_path__ + "img/usd.0330d444.svg";